"use client"
import type { Timeframe } from "@opensea/graphql"
import { Select, SelectItem, SelectItemTitle } from "@opensea/ui-kit"
import { toLowerCase } from "@opensea/utils"
import { useAnalyticsTimeframeQueryParam } from "@/hooks/query-param/use-analytics-timeframe-query-param"
import { useTimeframeEnumName } from "@/hooks/use-enum-name"

export function AnalyticsTimeframeSelect() {
  const { timeframe, setTimeframe } = useAnalyticsTimeframeQueryParam()

  const timeframeEnumName = useTimeframeEnumName()
  const timeframes = (
    [
      "ONE_HOUR",
      "ONE_DAY",
      "SEVEN_DAYS",
      "THIRTY_DAYS",
      "ONE_YEAR",
      "ALL_TIME",
    ] satisfies Timeframe[]
  ).map(key => ({
    key,
    label: timeframeEnumName(key),
  }))

  return (
    <div>
      <Select
        align="end"
        className="h-fit"
        dropdownSize="sm"
        onValueChange={value => setTimeframe(toLowerCase(value as Timeframe))}
        overrides={{
          Content: {
            className: "min-w-[72px]",
          },
        }}
        // TODO(robert): Make Select automatic display text work better on SSR
        renderValue={value =>
          timeframes.find(({ key }) => key === value)?.label || "All"
        }
        value={timeframe}
        variant="ghost"
      >
        {timeframes.map(({ key, label }) => (
          <SelectItem key={key} value={key}>
            <SelectItemTitle>{label}</SelectItemTitle>
          </SelectItem>
        ))}
      </Select>
    </div>
  )
}
